<template>
  <div>
    <el-row :gutter="5">
      <el-form ref="params" :model="params">
        <el-col :span="5" :xs="12">
          <el-form-item prop="cardNum">
            <el-input v-model="params.cardNum" maxlength="8" placeholder="输入卡片编号查询"/>
          </el-form-item>
        </el-col>
        <el-col :span="5" :xs="12">
          <el-form-item prop="phone">
            <el-input v-model="params.phone"   placeholder="输入手机号码查询"/>
          </el-form-item>
        </el-col>
        <el-col :span="2" :xs="12">
          <el-button type="primary" @click="search">搜索</el-button>
        </el-col>
        <el-col :span="2" :xs="12">
          <el-button plain type="success" @click="reset">重置</el-button>
        </el-col>
      </el-form>
    </el-row>
    <el-table v-loading="loadTable" :data="records" stripe @sort-change="sort_change">
      <el-table-column fixed label="原有卡号" prop="oldCardNum"/>
      <el-table-column label="绑定号码" prop="phone"/>
      <el-table-column label="转出卡号" prop="newCardNum"/>
      <el-table-column
          label="转出日期" prop="time">
        <template #default="scope">
          {{ timeFormat(scope.row.time) }}
        </template>
      </el-table-column>
      <el-table-column label="余额" prop="money"/>
      <el-table-column label="豆币" prop="token"/>
    </el-table>
    <page :current="current" :size="size" :total="total"/>
  </div>
</template>

<script>
import getCardChangeLogByPage from "@/api/user/card-change-log-manage/getCardChangeLogByPage";
import timeMixin from "@/mixin/timeMixin";
import searchMixin from "@/mixin/searchMixin";
import createdMixin from "@/mixin/createMixin";
import pageMixin from "@/mixin/pageMixin";
import dialogMixin from "@/mixin/dialogMixin";
import Page from "@/components/Page";
import formatPhone from "@/mixin/formatPhoneMixin";

export default {
  name: "ElectricityCardManageThree", components: {Page},
  mixins: [pageMixin, dialogMixin, timeMixin, searchMixin, createdMixin],
  data: () => ({
    number: "",
    phone: "",
    name: "",
    records: [],
    params: {
      cardNum: undefined,
      phone: undefined,
      sortName: 'id',
      sortType: 'DESC',
    },
  }),
  methods: {
    sort_change(e) {
      this.params.sortName = e.prop
      this.params.sortType = e.order == 'descending' ? 'DESC' : 'ASC'
      if (e.order == null) {
        this.params.sortName = null
        this.params.sortType = null
      }
      // console.log(this.params.sortName)
      // console.log(this.params.sortType)
      this.fetchData()
    },
    fetchData() {
      this.loadTable = true;
      getCardChangeLogByPage(this.params, this.current, this.size).then(res => {
            this.total = res.data.total;
            this.records = res.data.records
          }
      ).finally(() => {
        this.loadTable = false;
      });
    }
  },
  watch: {
    "params.phone": {
      handler() {
        this.params.phone = formatPhone(this.params.phone);
      },
    },
  },
}
</script>
